import React from "react";
import "./DirectorReport.scss";
import dReport1 from "../../../assets/Reports/Director's Report 1.png";
import dReport2 from "../../../assets/Reports/Director's Report 2.png";
import dReport3 from "../../../assets/Reports/Director's Report 3.png";
import dReport4 from "../../../assets/Reports/Director's Report 4.png";
import dReport5 from "../../../assets/Reports/Director's Report 5.png";

const DirectorReport = () => {
  return (
    <>
      <div className="director_report">
        <div className="container">
          <div className="heading_box">Director Report</div>
          {/* <div className="my-5 text-center">
            <img src={dReport1} className="img-fluid" alt="" />
          </div> */}
          <div className="row justify-content-center">
            <div className="col-lg-6 col-12 mb-3 mb-lg-5">
              <img src={dReport1} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-6 col-12 mb-3 mb-lg-5">
              <img src={dReport2} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-6 col-12 mb-3 mb-lg-5">
              <img src={dReport3} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-6 col-12 mb-3 mb-lg-5">
              <img src={dReport4} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-6 col-12 mb-3 mb-lg-3">
              <img src={dReport5} className="img-fluid" alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DirectorReport;
